export const STATES = ["AL","AK","AZ","AR","CA","CO","CT","DE","DC","FL","GA","HI","ID","IL","IN","IA","KS","KY","LA","ME","MD","MA","MI","MN","MS","MO","MT","NE","NV","NH","NJ","NM","NY","NC","ND","OH","OK","OR","PA","RI","SC","SD","TN","TX","UT","VT","VA","WA","WV","WI","WY"]

export const FLOCK_SIZE_TIERS = [
  { value: "Small", range: "0-12", description: "A starter flock — easy to keep track of by name." },
  { value: "Medium", range: "13-25", description: "A well-established backyard flock." },
  { value: "Large", range: "26-50", description: "Serious hobbyist territory — probably selling eggs." },
  { value: "Jumbo", range: "51+", description: "Small-farm scale — a sitter should have real flock experience." },
]

export const COOP_FEATURES = ["Automatic door", "Manual door", "Free range", "Tractor / mobile", "Fully enclosed", "Electric fence"]

export const SITTING_TYPES = [
  { value: "Temporary sitter", description: "A one-off — vacation, travel, or an emergency. Care for a fixed date range." },
  { value: "Recurring help & maintenance", description: "Ongoing, scheduled visits — daily or weekly care as a standing arrangement." },
]

export const CARE_TASKS = ["Feed & water", "Collect eggs", "Welfare check", "Cleaning", "Give treats / supplements"]

export const AVAILABILITY_DAYS = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"]

export const AVAILABILITY_TIMES = ["Morning", "Evening"]
